import { render } from "./AnnuaireDetails.vue?vue&type=template&id=1ba379a2&scoped=true"
import script from "./AnnuaireDetails.vue?vue&type=script&lang=js"
export * from "./AnnuaireDetails.vue?vue&type=script&lang=js"

import "./AnnuaireDetails.vue?vue&type=style&index=0&id=1ba379a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba379a2"]])

export default __exports__